module.exports = __webpack_public_path__ + "media/application/images/ui/icon-masthead-white-b457d3e20eeb6981f0aa68143145db2b.png";